{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "spending": {
    "label": "Team spending limit",
    "summary": "{{spent}} spent / {{limit}} monthly",
    "noLimit": "{{spent}} spent · no limit set"
  },
  "tabs": {
    "stores": "Stores ({{count}})",
    "members": "Members ({{count}})"
  },
  "stores": {
    "title": "Assigned stores",
    "assign": "Assign stores",
    "empty": "No stores assigned yet"
  },
  "store": {
    "Connected": "Connected",
    "Disconnected": "Disconnected",
    "remove": "Remove"
  },
  "members": {
    "empty": "No members in this team yet"
  },
  "assign": {
    "title": "Assign stores to team",
    "subtitle": "Select the stores this team should see. This replaces the current selection.",
    "unassignedBadge": "Unassigned",
    "save": "Save",
    "saving": "Saving..."
  },
  "toast": {
    "storesAssigned": "Stores assigned",
    "storeRemoved": "Store removed",
    "assignFailed": "Could not update store assignment",
    "staleConflict": "The assignment changed since you opened it — refreshing. Please review and try again.",
    "crossTeamConflict": "\"{{store}}\" already belongs to another team. Remove it there first."
  },
  "empty": {
    "notFound": {
      "title": "Team not found",
      "body": "This team may have been deactivated or the link is invalid.",
      "back": "Back to Teams"
    }
  },
  "error": {
    "loadFailed": "Could not load this team.",
    "retry": "Retry",
    "forbidden": {
      "title": "Access denied",
      "body": "You don't have permission to view this team. Contact your shop owner."
    }
  }
}
